// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"7":"customers","486":"orders","535":"login","690":"items","966":"dashboard"}[chunkId] + "." + {"7":"95106bd7","486":"28bdbc87","535":"032775d4","690":"24bd3562","966":"f1880ca0"}[chunkId] + ".js";
};